import React from 'react';
import './App.css';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import {Checkbox, FormControlLabel} from "@mui/material";

export default class InfoCollection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentType: '',
            email: ''
        }
        this.changePaymentType = this.changePaymentType.bind(this);
        this.changeState = this.changeState.bind(this);
        this.changeMemberCount = this.changeMemberCount.bind(this);
        this.handleConsentChange = this.handleConsentChange.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const param = urlParams.get('orderDetails'); // Replace 'param' with the actual parameter you're looking for
        if (!param) {
            return;
        }
        const bits = param.split('|');
        this.setState({
            ...this.state,
            paymentType: bits[0],
            perMember: 1000,
            purpose: bits[1],
            memberCount: bits[2],
            amount: bits[3] ? bits[3] : parseInt(bits[2] + '') * 1000,
            prefilled: true
        })
    }


    changePaymentType(e) {
        this.setState({
            ...this.state,
            paymentType: e.target.value,
            purposeDescriptor: this.props.paymentGatewayMap[e.target.value]['purposeLabel'] || 'Purpose',
            amount: this.props.paymentGatewayMap[e.target.value]['amount'] || '',
            perMember: this.props.paymentGatewayMap[e.target.value]['perMember'] || '',
            description: this.props.paymentGatewayMap[e.target.value]['desc'] || '',
            readOnly: !!this.props.paymentGatewayMap[e.target.value]['amount'],
            products: this.props.paymentGatewayMap[e.target.value]['products'],
            memberCount: 0
        })
    }

    changeState(e) {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        })
    }

    changeMemberCount(e) {
        this.setState({
            ...this.state,
            memberCount: e.target.value,
            amount: parseInt(e.target.value) * parseInt(this.state.perMember),
            readOnly: true
        })
    }

    handleConsentChange(e) {
        this.setState({
            ...this.state,
            consent: (this.state.consent ? undefined : Date.now().valueOf())
        })
    }

    submit(e) {
        let data = {
            invalidPaymentType: !this.state.paymentType,
            invalidPurpose: !this.state.purpose,
            invalidAmount: this.state.paymentType === 'regalia' ? false : (!this.state.amount || this.state.amount < 50),
            invalidName: !this.state.name || this.state.name.length < 5,
            invalidEmail: !this.state.email || this.state.email.length < 5 || !(this.state.email.includes('@') && this.state.email.includes('.')) || !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.email),
            invalidPhone: !this.state.phone || this.state.phone.length !== 10,
            invalidClubNum: !this.state.clubNum,
            invalidConsent: !this.state.consent
        }
        this.setState({
            ...this.state,
            ...data
        })
        for (let i = 0; i < Object.keys(data).length; i++) {
            let key = Object.keys(data)[i];
            let value = data[key]
            if (value) {
                return;
            }
        }

        this.props.onClick(this.state)
    }

    render() {
        console.log(this.state)
        return (
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{minHeight: '100vh'}}
            >
                <Paper elevation={10} className="background-paper">
                    <div style={{textAlign: 'center'}}>
                        <img src='https://assets.tangentindia.org/assets/national-logo.jpg' style={{width: '50%'}} alt='Tangent India Logo'/>
                    </div>
            <Box
                component="form"
                className="center mostly-filled"
                sx={{
                    '& > :not(style)': {m: 1},
                }}
                noValidate
                autoComplete="off"
            >
                <FormControl className="width40" fullWidth>
                    <InputLabel id="demo-simple-select-label">Payment Type</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={this.state.paymentType}
                        label="Payment Type"
                        onChange={this.changePaymentType}
                        error={this.state.invalidPaymentType}
                        disabled={this.state.prefilled}
                    >
                        {Object.keys(this.props.paymentGatewayMap).map((paymentType, idx) => {
                            return (
                                <MenuItem value={paymentType}
                                          key={idx}>{this.props.paymentGatewayMap[paymentType]['label']}</MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
                <TextField id="purpose" label={this.state.purposeDescriptor || "Purpose (eg. AAF Club #, Event Name, Project Name, New Member Name)"} variant="outlined"
                           value={this.state.purpose} name="purpose" onChange={this.changeState} error={this.state.invalidPurpose} disabled={this.state.prefilled} fullWidth/>
                {this.state.perMember && <TextField id="purpose" label="Member Count" variant="outlined" type='number' disabled={this.state.prefilled}
                           value={this.state.memberCount} name="memberCount" onChange={this.changeMemberCount} fullWidth/>}
                {this.state.description && <div dangerouslySetInnerHTML={{__html: this.state.description}} />}
                {this.state.paymentType === 'regalia' || <TextField id="amount" label={this.state.readOnly ? '' : "Amount"} variant="outlined"
                           type="number"
                           error={this.state.invalidAmount}
                           disabled={this.state.readOnly || this.state.paymentType === 'regalia' || this.state.prefilled}
                           value={this.state.amount} name="amount" onChange={this.changeState} fullWidth/>}
                <TextField id="name" label="Name of Payer" variant="outlined"
                           error={this.state.invalidName}
                           value={this.state.name} name="name" onChange={this.changeState} fullWidth/>
                <TextField id="email" label="Email" variant="outlined"
                           type="email"
                           error={this.state.invalidEmail}
                           value={this.state.email} name="email" onChange={this.changeState} fullWidth/>
                <TextField id="phone" label="Phone" variant="outlined" error={this.state.invalidPhone}
                           value={this.state.phone} name="phone" onChange={this.changeState} fullWidth/>
                <TextField id="clubNum" label="Club#" variant="outlined" error={this.state.invalidClubNum}
                           value={this.state.clubNum} name="clubNum" onChange={this.changeState} fullWidth/>
                <FormControlLabel control={<Checkbox
                    checked={this.state.consent}
                    onChange={this.handleConsentChange}
                    inputProps={{ 'aria-label': 'controlled' }}
                    sx={this.state.invalidConsent && {
                        color: 'red',
                        // '&.Mui-checked': {
                        //     color: 'red',
                        // },
                    }}
                />} label="I consent to receive communication (including SMS, WhatsApp and Email) from Tangent India confirming my payment once it has been processed." />

                <div className="center mid-margin"><Button variant="contained"
                                                           onClick={this.submit}>{this.state.paymentType === 'regalia' ? 'Select Products' : 'Pay Now'}</Button></div>
            </Box>
                </Paper>
            </Grid>
        );
    }
}